import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import { store } from "stores";
import { Provider } from "react-redux";
import { translate } from "reducers/i18n";
let errorDurationLength = 10000;

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    if (response.data.redirect) window.location.href = response.data.redirect;
    return response;
  },
  error => {    
    if (axios.isCancel && axios.isCancel(error)){
      return Promise.reject(error);
    }
    if ( error?.response?.data?.redirect){
      window.location.href = error.response.data.redirect;
    } 
    return Promise.reject(error);
  }
);

axios.interceptors.request.use(
  config => {
    if (
      localStorage.getItem("token") &&
      config.url.indexOf("/auth-url") < 0 &&
      config.url.indexOf("/authorize") < 0 &&
      config.url.indexOf("login/smslogin/requestcode") < 0 &&
      config.url.indexOf("login/smslogin/validatecode") < 0 &&
      config.url.indexOf("login/smslogin/validatemessageid") < 0
    )
      config.headers["Authorization"] =
        "Bearer " + localStorage.getItem("token");

    config.headers["Accept"] = "application/json, octet/stream";
    return config;
  },
  error => { 
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
